export enum ResponseRating {
  bad = 1,
  good = 5,
}
